import { render, staticRenderFns } from "./ProLpsModal.vue?vue&type=template&id=f700d7fe&scoped=true"
import script from "./ProLpsModal.vue?vue&type=script&lang=js"
export * from "./ProLpsModal.vue?vue&type=script&lang=js"
import style0 from "./ProLpsModal.vue?vue&type=style&index=0&id=f700d7fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f700d7fe",
  null
  
)

export default component.exports